import { Fragment, useState } from "react";
import { AlertTriangle } from "react-feather";
import { CloseButton, Toast, ToastBody } from "reactstrap";
import { Btn } from "../../../../AbstractElements";

const WarningToast = () => {
  const [visible, setVisible] = useState(false);
  const toggle = () => setVisible(!visible);
  const handleClick = () => {
    setVisible(true);
    setTimeout(() => setVisible(false), 8000);
  };
  return (
    <Fragment>
      <Btn color="warning" onClick={handleClick}>
        {"Warning Toast"}
      </Btn>
      <div className="toast-container position-fixed top-50 end-0 p-3 toast-index toast-rtl">
        <Toast fade isOpen={visible}>
          <div className="d-flex justify-content-between align-items-center alert-light-warning">
            <ToastBody>
              <AlertTriangle className="close-search stroke-warning" />
              {"Software drivers needed to be updated in advance"}
            </ToastBody>
            <CloseButton className="me-2 m-auto" onClick={toggle} />
          </div>
        </Toast>
      </div>
    </Fragment>
  );
};

export default WarningToast;
